module.exports = __webpack_public_path__ + "media/10.74fff115.wav";